import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const Redirect = ({ pageContext }) => {
	const { toPath } = pageContext;

	useEffect(() => {
		window.location.replace(toPath);
	}, [toPath]);

	return (
		<Helmet>
			<meta httpEquiv="refresh" content={`0;url=${toPath}`} />
			<meta name="robots" content="noindex, follow" />
			<link rel="canonical" href={toPath} />
		</Helmet>
	);
};

export default Redirect;
